
import Vue from 'vue'

const SET_LIST = (state, obj) => {
  state.list = obj.lista
}

const SET_ONE = (state, obj) => {
  const { index, usuario } = obj
  if (index > -1) {
    Vue.set(state.list, index, usuario)
  } else {
    state.list.unshift(usuario)
  }
}

const REMOVE_ONE = (state, obj) => {
  state.list.splice(obj.index, 1)
}

const VALIDATE = (state, obj) => {
  state.exist = { ...state.exist, ...obj }
}

const SET_QUANTIDADE_PAGINAS = (state, obj) => {
  state.quantidadeDePaginas = obj
}

export default {
  SET_LIST,
  SET_ONE,
  REMOVE_ONE,
  VALIDATE,
  SET_QUANTIDADE_PAGINAS
}



// WEBPACK FOOTER //
// ./src/features/admin/usuarios/store/mutations.js